import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { CoreService } from 'src/app/core-service/services/core-service.service';
import { environment } from 'src/environments/environment';
import { CommonService } from '../../services/common.service';

@Component({
  selector: 'app-dashboard-menu',
  templateUrl: './dashboard-menu.component.html',
  styleUrls: ['./dashboard-menu.component.scss']
})
export class DashboardMenuComponent implements OnInit {

  public assetsUrl = '';
  public isLOBUser: boolean = false;
  public showAgentManagerCard : boolean = true;
  public showAgentListing : boolean = true;
  isBranchAdminUser: boolean = false;
  isSuperAdminUser: Boolean = false;
  isOfficeManagerUser: Boolean = false;
  isDelegateUser: boolean = false;
  @Output() onManageBtn = new EventEmitter();
  @Output() onCoreManageBtn = new EventEmitter();
  isOfficeManagerSearchClicked = false;
  constructor(
    private coreService: CoreService,
    private commonService : CommonService) {
    // blank constructor
  }

  ngOnInit(): void {
    this.assetsUrl = environment.assetsUrl;
    this.isLOBUser = this.commonService.isLOBUser();
    this.isBranchAdminUser = this.commonService.isBranchAdminUser();
    this.isSuperAdminUser = this.commonService.isSuperAdminUser();
    this.isOfficeManagerUser = this.commonService.isOfficeManagerUser();
    this.isDelegateUser = this.commonService.getIsDelegateLoggedIn();
    this.isOfficeManagerSearchClicked = this.commonService.getOfficeManagerAgentSitesClick();
    this.checkingUserRole();
  }

/**
 * checking if the logged in user is core service Admin
 */
  public checkingUserRole(){
    if(this.isLOBUser || sessionStorage.getItem('coreServiceFromPortal')){      
      this.showAgentManagerCard = !this.isLOBUser;
      this.showAgentListing = !this.isLOBUser;
      if(sessionStorage.getItem('currentUrl'))
      {
        this.onCoreManageBtn.emit();
      }
    } else {
      if(sessionStorage.getItem('currentUrl') && !this.isOfficeManagerUser)
        {
          this.commonService.initAdminSearchForm();          
        }
      else {
        this.showAgentManagerCard = true;
        this.showAgentListing = true;
      }
    }
}

  /* on Manage action */
  onManage(path: string) {
    sessionStorage.removeItem('currentUrl');
    sessionStorage.removeItem('adminSearchData');
    if (path == 'agent-info') {
      this.onManageBtn.emit();
      this.commonService.setOnManageClick(true);
    } else if (path == 'web-listing') {
      if(this.isBranchAdminUser || this.isSuperAdminUser || this.isOfficeManagerUser) {
        window.open(environment.fnisToolsUrlBranchAdminUrl, '_self')
      }
      else if(this.isDelegateUser)
      {
          window.open('', '_self')
      } 
      else {
        window.open(environment.fnisToolsUrl, '_self');
      }      
    } else if(path == 'core-employee'){
      sessionStorage.setItem('coreServiceFromPortal', 'true');
      this.onCoreManageBtn.emit();
      this.commonService.goToCoreServiceFromPortal(true);
      this.commonService.setOnManageClick(false);
      this.coreService.setLastSearchEmployee(null);
    }
  }

}
